import { GregorioBar } from '../../gregorio-chant/enums/GregorioBar';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { calculateHeightPositionFromPitch } from '../utils';
import { VisualizerHelper } from '../visualizers/VisualizerHelper';

export class DivisioMinor extends ChantLayoutElement {
  private readonly _bar: GregorioBar;

  constructor(context: ChantContext, bar: GregorioBar) {
    super(context);
    this._bar = bar;
    this.bounds.setWidth(1);
  }

  public performLayout(prevElements: ChantLayoutElement[]): void {
    const prev = VisualizerHelper.findLastGlyphOrSpaceOrBarOrSign(prevElements);

    if (prev) {
      this.bounds.setX(prev.bounds.right);
    } else {
      this.bounds.setX(0);
    }

    let y = 0;
    let height = 0;
    const staffInterval = this._context.staffLinesInterval;

    switch (this._bar) {
      case GregorioBar.DIVISIO_MINOR:
        // eslint-disable-next-line no-case-declarations
        height = staffInterval * 4;
        y = calculateHeightPositionFromPitch(this._context, 9) - height / 2;
        break;

      case GregorioBar.DIVISIO_MINOR_D1:
        y = calculateHeightPositionFromPitch(this._context, 9);
        height = staffInterval * 3;
        break;
      case GregorioBar.DIVISIO_MINOR_D2:
        y = calculateHeightPositionFromPitch(this._context, 8);
        height = staffInterval * 3;
        break;
      case GregorioBar.DIVISIO_MINOR_D3:
        y = calculateHeightPositionFromPitch(this._context, 11);
        height = staffInterval * 3;
        break;
      case GregorioBar.DIVISIO_MINOR_D4:
        y = calculateHeightPositionFromPitch(this._context, 10);
        height = staffInterval * 3;
        break;
      case GregorioBar.DIVISIO_MINOR_D5:
        y = calculateHeightPositionFromPitch(this._context, 13);
        height = staffInterval * 3;
        break;
      case GregorioBar.DIVISIO_MINOR_D6:
        y = calculateHeightPositionFromPitch(this._context, 12);
        height = staffInterval * 3;
        break;
    }

    this.bounds.setY(y);
    this.bounds.setHeight(height);
    // this.bounds.setWidth(this._context.staffLinesInterval * 4);
  }

  public createSvgFragments(): SVGElement[] {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('class', 'DivisioMinor');
    line.setAttribute('x1', String(this.bounds.x));
    line.setAttribute('y1', String(this.bounds.y));
    line.setAttribute('x2', String(this.bounds.x));
    line.setAttribute('y2', String(this.bounds.bottom));
    line.setAttribute('stroke', '#000000');
    line.setAttribute('stroke-width', '1');

    return [
      ...super.createSvgFragments(),
      line,
    ];
  }
}
